














































































































import { Vue, Component, Mixins } from "vue-property-decorator";
import { BvTableFieldArray, BvTableCtxObject } from 'bootstrap-vue';
import { VIPCompanyRefreshTableMixin } from '@/mixins/VIPCompanyMixin';
import { VIPCompanyRest, VIPCompany } from '@/loader/public';

@Component
export default class CompaniesTable extends Mixins(VIPCompanyRefreshTableMixin) {
	public name: string = "";

	public get fields(): BvTableFieldArray {
		return [
			{
				key: "img",
				label: "Logo",
				sortable: false,
				tdClass: "py-0"
			},
			{
				key: "name",
				label: "Clients",
				sortable: !this.noSorting,
			},
			{
				key: "projects",
				label: "#Projets",
			}
		];
	}

	public getCompanies(context: BvTableCtxObject, callback: Function) {
		VIPCompanyRest.list({
			page: context.currentPage,
			per_page: context.perPage,
			search: context.filter || undefined,
			orderby: context.sortBy,
			order: context.sortDesc ? "desc" : "asc",
			options: {
				contacts: true,
				projects: {
					manager: true,
					ips: true,
				}
			}
		}).then(result => {
			this.setResult(callback, result);
		});
		return null;
	}
}
